'use client';

import { PublisherAssetsListing } from '@components/Blocks/PublisherAssets/PublisherAssetsListing';
import { analytics } from '@lib/analytics/page-events';
import { useCookieSettings } from '@lib/hooks/useCookieSettings';
import { useEffect, useRef, useState } from 'react';
import { PublisherProfileTemplate } from 'ui-components';
import { PublisherProfilePageProps } from './types';

export const PublisherProfilePage = ({
  microcopy,
  paginationMicrocopy,
  ...initialData
}: PublisherProfilePageProps) => {
  const { openCookieSettings, hasCookieConsent } = useCookieSettings();
  const [data, setData] = useState(initialData);
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!hasTracked.current && data.publisherInfo?.publisherName) {
      analytics.pushPublisherVisitedEvent({
        publisher_id: data.publisherId,
        publisher_name: data.publisherInfo.publisherName,
      });

      analytics.pushPublisherPageViewEvent(
        data.publisherId,
        data.publisherInfo.publisherName
      );

      hasTracked.current = true;
    }
  }, [data.publisherId, data.publisherInfo?.publisherName]);

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      overview: {
        ...prev.overview,
        hasCookieConsent,
      },
    }));
  }, [hasCookieConsent]);

  return (
    <PublisherProfileTemplate
      microcopy={microcopy}
      {...data}
      renderPublisherAssets={() => (
        <PublisherAssetsListing
          uniqueId="PublisherAssets-Profile"
          paginationMicrocopy={paginationMicrocopy}
        />
      )}
      onOpenCookieSettings={openCookieSettings}
    />
  );
};
